module.exports = __webpack_public_path__ + "img/kjrc.0a5f048.png";